import React, { useState, useEffect } from "react";
import {
  PlusCircle,
  TrendingUp,
  CheckCircle,
  FileText,
  Sparkles,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

// Updated Tabs for the workflow
const tabs = [
  "For Estimation", // List qualified leads
  "In Process", // Estimations waiting for approval
  "Job Card", // Approved items
];

const ContractDashboard = () => {
  const [activeTab, setActiveTab] = useState("For Estimation");
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // --- API FETCHING LOGIC ---
  useEffect(() => {
    const fetchLeads = async () => {
      setLoading(true);
      try {
        // Constructing the URL with the current date (based on instructions: 2026-02-17)

        // here also call api as in Table.js so no task_coordinator=-&task_salesperson=-&task_creator_id=- will be there in url
        const response = await fetch(
          "https://cubixweberp.com:213/api/CRMLeadMainList/SUNRISEWEB/ALL/-/-/-/-/MAIN/1900-01-01/2026-02-17/-/qualified/-?task_coordinator=-&task_salesperson=-&task_creator_id=-",
        );
        const data = await response.json();
        console.log("response Data", data);
        // LIMIT TO FIRST 50 VALUES
        setLeads(data?.slice(0, 50));
      } catch (error) {
        console.error("Error fetching leads:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []); // Empty dependency array means this runs once on mount

  // --- ACTIONS ---
  const handleCreateEstimation = (leadId) => {
    console.log(`Redirecting to Estimation Screen for Lead ID: ${leadId}`);
    // Example: history.push(`/create-estimation/${leadId}`);
    navigate(`/contract_quot/${leadId}`, { state: { leadId: leadId } });
  };

  const handleApprove = (leadId) => {
    console.log(`Approving Estimation for Lead ID: ${leadId}`);
    // API call to update status
  };

  return (
    <div className="bg-gray-50 p-6 min-h-screen">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-bold text-2xl text-gray-800">Project Dashboard</h1>
        <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-semibold">
          <PlusCircle size={18} /> New Lead
        </button>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-200 mb-6 bg-white rounded-t-lg px-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-4 text-sm font-semibold ${
              activeTab === tab
                ? "text-blue-600 border-b-2 border-blue-600"
                : "text-gray-400 hover:text-gray-600"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Table Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-gray-500">Loading leads...</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="text-xs text-gray-400 uppercase bg-gray-50/50">
                <tr>
                  <th className="px-6 py-4">Lead ID</th>
                  <th className="px-6 py-4">Entry Time</th>
                  <th className="px-6 py-4">Customer / Organization</th>
                  <th className="px-6 py-4">Primary Contact</th>
                  <th className="px-6 py-4">Salesperson</th>
                  <th className="px-6 py-4">LEAD SOURCE</th>

                  <th className="px-6 py-4 text-center">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {leads?.map((lead) => (
                  <tr key={lead.lead_id} className="hover:bg-gray-50/50">
                    <td className="px-6 py-4 font-semibold text-gray-900">
                      {lead.lead_id}
                    </td>
                    <td className="px-6 py-4 text-gray-600">
                      {new Date(lead.lead_entryTime).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4">
                      <div className="font-medium text-gray-900">
                        {lead.lead_organization}
                      </div>
                      <div className="text-xs text-gray-400">
                        {lead.lead_city}, {lead.lead_country}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-gray-600">
                      {lead.lead_primarycontact} <br />
                      <span className="text-xs text-blue-600">
                        {lead.lead_phone}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-600">
                      {lead?.lead_salespersonName?.split(",")[0]}
                    </td>
                    <td className="px-6 py-4">
                      {lead?.lead_source === "Email-AI" ? (
                        <div className="flex items-center gap-2 bg-purple-100 text-purple-700 px-3 py-1 rounded-full w-fit">
                          <Sparkles className="w-5 h-5" />
                          <span className="font-semibold text-sm">AI Lead</span>
                        </div>
                      ) : (
                        <p className="text-gray-600">{lead?.lead_source}</p>
                      )}
                    </td>

                    <td className="px-6 py-4 text-right">
                      <td className="px-6 py-4 text-right">
                        {activeTab === "For Estimation" && (
                          <button
                            onClick={() => handleCreateEstimation(lead.lead_id)}
                            className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-white rounded-md text-xs font-semibold ${
                              lead?.lead_source === "Email-AI"
                                ? "bg-purple-600"
                                : "bg-green-700"
                            }`}
                          >
                            <PlusCircle size={14} />
                            {lead?.lead_source === "Email-AI"
                              ? "Create AI Estimation"
                              : "Create Estimation"}
                          </button>
                        )}
                      </td>

                      {activeTab === "In Process" && (
                        <button
                          onClick={() => handleApprove(lead.lead_id)}
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-md hover:bg-blue-100 text-xs font-semibold"
                        >
                          <CheckCircle size={14} /> Approve
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractDashboard;
